import defaultReducer from "./defaultReducer";

const initialState = {
  site: "",
  countDate: "",
  min: "",
  pos: "",
  game: "",
  open: false,
  activeRow: { collectionType: null, collectionId: null },
  curr50: 0,
  curr20: 0,
  curr10: 0,
  curr5: 0,
  currCoins: 0,
  new50: 0,
  new20: 0,
  new10: 0,
  new5: 0,
  newCoins: 0,
  Comments: "",
  loading: false,
};

export default defaultReducer("EDIT_MACHINE_COUNT_MODAL", initialState);
